import createIsSubmitting from '../selectors/isSubmitting';
import immutable from '../structure/immutable';

export default createIsSubmitting(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/isSubmitting.js
// module id = 1208
// module chunks = 0